/**
 * Surfaces that run on the server's conversation engine (Interview Prep,
 * Language Learning, conversation-based exams) are switched OFF — not broken —
 * when GET /capabilities reports `conversation.engine: false`. That is a
 * configuration of this environment, so the copy says so plainly and implies
 * no retry; "not available right now" stays for genuine load errors.
 */
import { useGetCapabilitiesQuery } from '../store/api/capabilitiesApi';

export function useConversationEngineSwitch(): { loading: boolean; off: boolean } {
  const { data, isLoading } = useGetCapabilitiesQuery();
  return { loading: isLoading, off: data?.conversation?.engine === false };
}

export function conversationEngineOffCopy(feature: string): string {
  return `${feature} is not switched on for this BeHeard environment.`;
}

export function ConversationEngineOffNotice({ feature }: { feature: string }) {
  return (
    <div className="rounded-lg bg-gray-50 border border-gray-200 p-4" data-testid="conversation-engine-off">
      <p className="text-sm text-gray-700">{conversationEngineOffCopy(feature)}</p>
    </div>
  );
}
